import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {createPubEditor} from 'services/pubs';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import {getSingleEditorACS} from 'store/singlePageEditor/requestAC';
import ApiData from 'typescript/interfaces/ApiData';
import PageEditor from 'typescript/models/PageEditor';

import {addPubEditorAC} from '../pubPageSlice';
import {assignPubEditorACS} from '../requests';

export function* assignPubEditorSaga(action: ReturnType<typeof assignPubEditorACS>) {
  try {
    const response: AxiosResponse<ApiData<PageEditor>> = yield call(createPubEditor, action.payload);

    yield put(addPubEditorAC(response.data.data));
    yield put(getSingleEditorACS(String(action.payload.userId)));
    yield put(setSuccessAC('Pub editor assigned successfully'));
  } catch (error) {
    yield call(handleError, error, 'Failed to assign pub editor');
  }
}
